<div onsip-grid-placement-shelf class="recording-view-container">
  <div class="first-column">
    <div class="mat-body-1 recording-view-element">Current announcement</div>
    <div class="recording-view-element">{{ recording?.name }}</div>
    <div class="announcements-recording-audio-container">
      <audio
        #messageAudio
        class="announcement-message"
        [attr.src]="audioFile | safeSrc"
        controls
        controlsList="nodownload"
      ></audio>
      <div class="recording-download-button">
        <a
          id="announcement-recording-download"
          [href]="audioFile | safeSrc"
          download
          type="audio/wav"
        >
          <mat-icon class="recording-download-icon" aria-label="file_download"
            >file_download</mat-icon
          >
        </a>
      </div>
      <div class="replace-button-container">
        @if (!isMobile) {
        <button mat-button class="replace-button" color="primary" (click)="togglePanel()">
          Replace
        </button>
        }
      </div>
    </div>
    @if (isMobile) {
    <button mat-button class="mobile-replace-button" color="primary" (click)="togglePanel()">
      Replace
    </button>
    }
  </div>
</div>
